export type WizardStep = "step-sources" | "step-handoff" | "step-activate"

// IMP-461: the reduced guide — the assistant builds the responder from the
// business profile first (building beat), then lead sources, one handoff
// decision (IMP-469: transfer and booking configure the same moment — what
// to do with a lead who's ready — so they share a step), and test & go
// live. Identity (voice/tone/disclosure) is account-level (IMP-456);
// qualifying, cadence, and free-text guidance live in the edit drawer.
export const STEP_ORDER: WizardStep[] = [
  "step-sources",
  "step-handoff",
  "step-activate",
]

export const STEP_TITLE: Record<WizardStep, string> = {
  "step-sources": "Lead sources",
  "step-handoff": "Handoff",
  "step-activate": "Test and go live",
}

// Legacy keys from the pre-IMP-461 wizard resume at the nearest survivor.
export const LEGACY_STEP_MAP: Record<string, WizardStep> = {
  "step-channels": "step-sources",
  "step-qualifying": "step-handoff",
  "step-routing": "step-handoff",
  "step-cadence": "step-handoff",
  "step-booking": "step-handoff",
  "step-transfer": "step-handoff",
  "step-compliance": "step-activate",
  "step-customization": "step-activate",
}

export function stepFor(raw: string | null | undefined): WizardStep {
  if (STEP_ORDER.includes(raw as WizardStep)) return raw as WizardStep
  return LEGACY_STEP_MAP[raw ?? ""] ?? "step-sources"
}
